<template>
    <teleport to="#modal">
        <teleport to="#modal">

            <Loading :visible="loading"> </Loading>
            <CercaModal
                :settori_initial="$route.query.settori"
                :contatti_initial="$route.query.contatti"
                :accounts_initial="$route.query.accounts"
                :presentazioni_initial="$route.query.presentazioni"
                :responsabili_initial="$route.query.responsabili"
                :bu_initial="$route.query.bu"
                :text_initial="$route.query.text"
                :stato_initial="$route.query.stato"
                :ultimo_contatto_a_initial="$route.query.ultimo_contatto_a"
                :ultimo_contatto_da_initial="$route.query.ultimo_contatto_da"
                :nazioni_initial="$route.query.aziende_estere"

                v-if="cercaModalVisibility"
                back
                @reject="cercaModalVisibility = false"
                @confirm="cerca"
            ></CercaModal>
        </teleport>
    </teleport>

    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto pb-5">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
            </div>
            <h3 class="text-3xl font-bold mb-5">Risultati Ricerca</h3>
            <div class="flex items-center justify-between w-full">
                <div class="flex items-center w-1/2">
                    <div class="flex flex-col grow">
                        <Field
                            :labelVisible="false"
                            v-model="searchString"
                            placeholder="Cerca"
                        ></Field>
                    </div>
                    <div>
                        <i
                            @click="cercaModalVisibility = !cercaModalVisibility"
                            class="pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
                        ></i>
                    </div>
                </div>
                <div>
                    <NextButton
                        @click="buttonSearch"
                        class="px-3 py-1"
                        variant="outline-secondary"
                    >
                        Cerca
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-end py-10">
                <Switcher v-model="tab" :options="getSwitchOptions"></Switcher>
            </div>
            <div v-if="tab === 0">
                <!--Clienti-->
                <div class="flex justify-between items-center mb-3">
                    <h3 class="font-medium text-3xl">Clienti</h3>
                    <div>
                        <NextButton
                            variant="outline-secondary"
                            v-if="
                                !loadingScaricaClienti &&
                                !showClientiExportSuccess
                            "
                            @click="scarica('cl')"
                            class="px-3 py-1"
                        >
                            Scarica XLSX
                        </NextButton>
                        <div
                            v-if="loadingScaricaClienti"
                            aria-disabled="true"
                            class="relative flex justify-center border-2 border-next-neu text-center hover:bg-next-neu hover:text-white px-3 py-1 ml-3 w-[129px]"
                        >
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <p
                            v-if="
                                showClientiExportSuccess &&
                                !loadingScaricaClienti
                            "
                            class="text-next-bri col-span-2"
                        >
                            Il file è in generazione,<br />attendi il
                            completamento e scaricalo nella
                            <RouterLink
                                :to="{ name: 'DownloadCenter' }"
                                target="_blank"
                                class="underline"
                                >sezione download.</RouterLink
                            >
                        </p>
                    </div>
                </div>
                <ClientiSearchResult
                    v-for="c in listaClienti.rows"
                    :c="c"
                    :key="c.id"
                    :businessUnits="businessUnits"
                >
                </ClientiSearchResult>
                <InfiniteLoading
                    @infinite="listaClienti.fetchNextPage"
                    :identifier="listaClienti.identifier"
                    style="min-height: 1px"
                >
                    <template #complete>
                        <div class="text-center pb-3">
                            Non ci sono altri clienti.
                        </div>
                    </template>
                </InfiniteLoading>
                <!-- <p v-if="!listaClienti.rows.length" class="mb-3">
                    Nessun cliente trovato secondo i parametri di ricerca
                </p> -->
            </div>
            <div v-else>
                <!--Contatti-->
                <div class="flex justify-between items-center mb-3">
                    <h3 class="font-medium text-3xl">Contatti</h3>
                    <div>
                        <NextButton
                            variant="outline-secondary"
                            v-if="
                                !loadingScaricaContatti &&
                                !showContattiExportSuccess
                            "
                            @click="scarica('co')"
                            class="px-3 py-1"
                        >
                            Scarica XLSX
                        </NextButton>
                        <div
                            v-if="loadingScaricaContatti"
                            aria-disabled="true"
                            class="relative flex justify-center border-2 border-next-neu text-center hover:bg-next-neu hover:text-white px-3 py-1 ml-3 w-[129px]"
                        >
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <p
                            v-if="
                                showContattiExportSuccess &&
                                !loadingScaricaContatti
                            "
                            class="text-next-bri col-span-2"
                        >
                            Il file è in generazione,<br />attendi il
                            completamento e scaricalo nella
                            <RouterLink
                                :to="{ name: 'DownloadCenter' }"
                                target="_blank"
                                class="underline"
                                >sezione download.</RouterLink
                            >
                        </p>
                    </div>
                </div>
                <ContattiSearchResult v-for="c in listaContatti.rows" :c="c">
                    <!-- <template v-slot:download_button>
                        <div
                            v-if="loadingScaricaClienti"
                            aria-disabled="true"
                            class="relative flex justify-center border-2 border-next-neu text-center hover:bg-next-neu hover:text-white px-3 py-1 ml-3 w-[129px]"
                        >
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <NextButton
                            variant="outline-secondary"
                            v-else
                            @click="scarica('co')"
                            class="px-3 py-1 ml-3"
                            >Scarica XLSX</NextButton
                        >
                    </template> -->
                </ContattiSearchResult>
                <InfiniteLoading
                    @infinite="listaContatti.fetchNextPage"
                    :identifier="listaContatti.identifier"
                    style="min-height: 1px"
                >
                    <template #complete>
                        <div class="text-center pb-3">
                            Non ci sono altri contatti.
                        </div>
                    </template>
                </InfiniteLoading>
                <!-- <p v-if="!listaContatti.rows.length" class="mb-3">
                    Nessun contatto trovato secondo i parametri di ricerca
                </p> -->
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue, setup } from "vue-class-component";
import Loading from "@/components/Loading.vue";
import searchManager from "../api/Search";
import Topbar from "@/components/Topbar.vue";
import ClientiSearchResult from "@/components/ClientiSearchResult.vue";
import { Watch } from "vue-property-decorator/lib/decorators/Watch";
import ContattiSearchResult from "@/components/ContattiSearchResult.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import Switcher from "@/components/Switcher.vue";
import Field from "@/components/Field.vue";
import CercaModal from "./CercaModal.vue";
import InfiniteLoading from "v3-infinite-loading";
import clientiManager from "../api/Clienti";
import Lista from "@/setup/ListaCerca";
import businessUnitsManager from "../api/BusinessUnits";
import contattiManager from "../api/Contatti";

@Options({
    name: "Search",
    components: {
        NextButton,
        Loading,
        Breadcrumbs,
        Topbar,
        ClientiSearchResult,
        ContattiSearchResult,
        Switcher,
        Field,
        CercaModal,
        InfiniteLoading,
    },
})
export default class Search extends Vue {
    clienti: any[] = [];
    contatti: any[] = [];
    loading = false;
    loadingScaricaClienti = false;
    loadingScaricaContatti = false;
    showClientiExportSuccess = false;
    showContattiExportSuccess = false;
    showClientiExportSuccessTimerId: any = null;
    showContattiExportSuccessTimerId: any = null;
    tab = 0;
    businessUnits: any[] = [];
    cercaModalVisibility = false;
    searchString = "";

    listaClienti: any = setup(() =>
        Lista(clientiManager, [], clientiManager.search)
    );

    listaContatti: any = setup(() =>
        Lista(contattiManager, [], contattiManager.search)
    );

    created(): void {
        businessUnitsManager
            .businessUnits({ params: { crm: 1 } })
            .then((response) => {
                this.businessUnits = response.data;
            });
    }

    cerca(data: any) {
        this.cercaModalVisibility = false;
        //@ts-ignore
        this.$router.push({ query: data });
    }

    buttonSearch(){
        //@ts-ignore
        this.$router.push({ query: { text: this.searchString } });
    }

    mounted() {
        this.search();
    }

    get getSwitchOptions() {
        return ["Clienti", "Contatti"];
    }

    @Watch("$route")
    search() {
        this.loading = true;
        //@ts-ignore
        this.searchString = this.$route.query.text ?? "";
        //@ts-ignore
        this.listaClienti.apiParams = this.$route.query;
        //@ts-ignore
        this.listaContatti.apiParams = this.$route.query;

        Promise.all([
            this.listaClienti.reset(),
            this.listaContatti.reset(),
        ]).finally(() => {
            this.loading = false;
        });
    }

    scarica(type: "cl" | "co") {
        if (type === "cl") {
            this.loadingScaricaClienti = true;
            clientiManager
                //@ts-ignore
                .export({ params: this.$route.query })
                .then(() => {
                    this.showClientiExportSuccess = true;
                    this.showClientiExportSuccessTimerId = setTimeout(() => {
                        this.showClientiExportSuccess = false;
                        this.showClientiExportSuccessTimerId = null;
                    }, 10000);
                })
                .finally(() => {
                    this.loadingScaricaClienti = false;
                });
        } else {
            this.loadingScaricaContatti = true;
            contattiManager
                //@ts-ignore
                .export({ params: this.$route.query })
                .then(() => {
                    this.showContattiExportSuccess = true;
                    this.showContattiExportSuccessTimerId = setTimeout(() => {
                        this.showContattiExportSuccess = false;
                        this.showContattiExportSuccessTimerId = null;
                    }, 10000);
                })
                .finally(() => {
                    this.loadingScaricaContatti = false;
                });
        }

        this.loadingScaricaClienti = true;
    }

    beforeUnmount(): void {
        if (this.showClientiExportSuccessTimerId) {
            clearTimeout(this.showClientiExportSuccessTimerId);
        }
        if (this.showContattiExportSuccessTimerId) {
            clearTimeout(this.showContattiExportSuccessTimerId);
        }
    }

    paths = [
        {
            title: "Home",
            name: "Dashboard",
        },
        {
            title: "Risultati della ricerca",
            name: "Search",
        },
    ];
}
</script>

<style lang="scss"></style>
